module.exports = __webpack_public_path__ + "media/3x/Q-cfa6bf8f.png";